import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import { fetchAdminList } from "stores/actions/list";
import { useList } from "stores/hooks/list";

const AdminListProvider = () => {
  const { listUuid } = useParams();
  const list = useList();

  useEffect(() => {
    if (!listUuid) {
      return;
    }

    // fetch some data
    fetchAdminList(listUuid);
  }, [listUuid]);

  // make sure the list exists and the list is the same as the requested
  if (!list || list.uuid !== listUuid) {
    return null;
  }

  return <Outlet />;
};

export default AdminListProvider;
